import createRoute        from '@widesk-ui/tools/createRoute';
import StandTypologyModel from '@models/website/StandTypologyModel';

const route = createRoute.dashboardFromModel(
	StandTypologyModel,
	'StandTypologyDashboard',
	{
		pathPrefix: '/configuration',
	},
);
export default route;
